import { useQuery } from "@tanstack/react-query";
import { TagParams } from "../model/types";
import { tagApi } from "./client";

export const useTags = (params: TagParams) =>
  useQuery({
    queryKey: ["tags", params],
    queryFn: () => tagApi.getAll(params),
  });
